import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import T from '../../Utils/Locale';
import PropTypes from 'prop-types';
function PriceBoxTypeButton({ buttonClass, purchaseType, setPurchaseType, active, clickable }) {
    return (_jsx("li", Object.assign({ className: buttonClass }, { children: _jsx("button", Object.assign({ className: `tailwind-reset xs:h-12 appearance-none w-full xs:py-3 py-4 focus:outline-none text-xs text-gray-47 bg-gray-f6 md:py-3 md:text-sm cursor-pointer ${active} ${clickable ? '' : 'line-through'}`, onClick: () => setPurchaseType(purchaseType), "data-testid": `button-${purchaseType}`, disabled: !clickable }, { children: T(`dashboard.purchase_types.${purchaseType}`) })) })));
}
PriceBoxTypeButton.propTypes = {
    buttonClass: PropTypes.string.isRequired,
    purchaseType: PropTypes.string.isRequired,
    setPurchaseType: PropTypes.func.isRequired,
    active: PropTypes.string.isRequired,
    clickable: PropTypes.bool.isRequired
};
export default PriceBoxTypeButton;
